import {
  WhmButton,
  WhmStack,
  whmTheme,
  WhmTypography,
} from "@securitize/reactjs-whm";
import { translationKeys } from "../../../../../contexts/I18nContext";
import { Translate } from "../../../../Translation/Translate";
import { WhmResponsiveStack } from "../../../../shared/WhmResponsiveStack";

interface SettingsChangePasswordProps {
  onChangePassword: () => void;
}

export const SettingsChangePassword = ({
  onChangePassword,
}: SettingsChangePasswordProps) => {
  return (
    <WhmResponsiveStack gap="8px">
      <WhmStack direction="column" gap="4px">
        <WhmTypography variant="body2" color={whmTheme.palette.text.primary}>
          <Translate
            translationKey={
              translationKeys.PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_TITLE
            }
          />
        </WhmTypography>
        <WhmTypography variant="body2" color={whmTheme.palette.text.secondary}>
          <Translate
            translationKey={
              translationKeys.PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_SUBTITLE
            }
          />
        </WhmTypography>
      </WhmStack>
      <WhmButton
        variant={"outlined"}
        color="primary"
        onClick={onChangePassword}
        data-test-id="profile-settings-2fa-cta"
        sx={{
          minWidth: "fit-content",
          alignSelf: { xs: "flex-start", xl: "center" },
        }}
      >
        <Translate
          translationKey={
            translationKeys.PROFILE_SETTINGS_SECURITY_CARD_PASSWORD_CTA
          }
        />
      </WhmButton>
    </WhmResponsiveStack>
  );
};
